export default {
  storyboard: true,
  return: true,
  template: true,
  audio: true,
  comments: true,
  script: true,
  inspiration: true,
  remove: true,
  document: true,
  edit: true
};